import axios from 'axios'
import { API_URL } from 'services/config'
import QuoteEntity from 'models/QuoteEntity'
import Paginator from 'models/Paginator'
import InsuranceBroker from 'models/InsuranceBroker'
import insuranceAutomatic from 'models/InsuranceAutomatic'
import insuranceManual from 'models/InsuranceManual'
import commercialTerms from 'models/CommercialTerms'

class QuotesService {
    getQuotes = (params) =>
        axios.get(`${API_URL}/multi-quotes`, { params }).then(({ data: { data, pagination } }) => {
            return {
                quotes: data.map((quote) => {
                    return QuoteEntity.fromJson(quote)
                }),
                paginator: Paginator.fromJson(pagination),
            }
        })

    getInsuranceCompany = (insuranceCompany) =>
        axios.get(`${API_URL}/insurance-companies/${insuranceCompany}`).then(({ data }) => {
            const insuranceBroker = InsuranceBroker.fromJson(data.data.broker)
            const insurancesAutomatic = data.data.insurances.automatic.map((insurance) =>
                insuranceAutomatic.fromJson(insurance)
            )
            const insurancesManual = data.data.insurances.manual.map((insurance) =>
                insuranceManual.fromJson(insurance)
            )

            return { insuranceBroker, insurancesAutomatic, insurancesManual }
        })

    getCoverageData = (insuranceCompany, coverageType) =>
        axios
            .get(`${API_URL}/insurance-companies/${insuranceCompany}/${coverageType}`)
            .then(({ data }) => commercialTerms.fromJson(data.data.commercialTerms))

    getQuotesPermissions = () =>
        axios.get(`${API_URL}/multi-quoter/types/permissions`).then(({ data }) => data.data)
}

export default QuotesService
